import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block cursor-pointer">
              <span className="text-xl md:text-2xl font-heading font-bold text-background-50 tracking-tight">
                VigorBuy
              </span>
            </Link>
            <p className="text-sm text-foreground-400 mt-4 leading-relaxed max-w-xs">
              The largest independent Vigorbuy Spreadsheet resource center. Discover curated finds, buying guides, and updated spreadsheet links.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">Categories</h4>
            <ul className="space-y-2">
              {categories.slice(0, 7).map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-400 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">More Categories</h4>
            <ul className="space-y-2">
              {categories.slice(7).map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-400 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">Stay Updated</h4>
            <p className="text-sm text-foreground-400 mb-4 leading-relaxed">
              Get notified when the Vigorbuy Spreadsheet is updated with new finds.
            </p>
            <form
              data-readdy-form
              action="https://readdy.ai/api/form/d90jehus51g94qljs73g"
              method="POST"
              className="flex flex-col gap-2"
            >
              <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" />
              <div className="flex">
                <input
                  type="email"
                  name="email"
                  placeholder="Your email address"
                  required
                  className="flex-1 px-4 py-2.5 rounded-l-full bg-foreground-800 border border-foreground-700 text-sm text-background-50 placeholder:text-foreground-500 outline-none focus:border-primary-500 transition-colors"
                />
                <button
                  type="submit"
                  className="px-5 py-2.5 rounded-r-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Subscribe
                </button>
              </div>
            </form>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} VigorBuy Spreadsheet Hub. Independent resource — not affiliated with any brand.
          </p>
          <div className="flex items-center gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="text-xs text-foreground-500 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer"
            >
              vigorbuy sheet
            </a>
            <Link to="/guide/vigorbuy-spreadsheet-guide" className="text-xs text-foreground-500 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">
              Guides
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}